export const NAME = 'toast';
export const TOAST_LIFESPAN_SEC = 5;



// WEBPACK FOOTER //
// ./src/redux/modules/toast/constants.js